export class UserRegistrationDTO {

    constructor(
        stateAndLicensePlate, 
        coverageArea,
        os
    ) {
        this.stateAndLicensePlate = stateAndLicensePlate
        this.coverageArea = coverageArea
        this.os = os
    }

    toJSON() {
        return {
            stateAndLicensePlate: this.stateAndLicensePlate,
            coverageArea: this.coverageArea,
            os: this.os
        }
    }
}

export class NotifyJakeDTO {

    constructor(
        msg
    ) {
        this.msg = msg
    }

    toJSON() {
        return {
            msg: this.msg
        }
    }
}

export class SavePhoneDTO {

    constructor(
        phone,
        language = null
    ) {
        this.phone = phone
        this.language = language
    }

    toJSON() {
        const json = {
            phone: this.phone
        }
        // Only send language when we actually have one, so the backend keeps
        // treating an absent field as "never captured" (NULL).
        if (this.language) {
            json.language = this.language
        }
        return json
    }
}

export class NotificationPreferencesDTO {
    constructor(
        emailPref,
        textPref,
        apnsPref
    ) {
        this.emailPref = emailPref
        this.textPref = textPref
        this.apnsPref = apnsPref
    }

    toJSON() {
        return {
            emailPref: this.emailPref,
            textPref: this.textPref,
            apnsPref: this.apnsPref
        }
    }
}

export class Me {
    constructor(
        blockReason,
        blocked,
        customer,
        deservesInitialIncentive,
        deservesReward1,
        deservesReward2,
        deviceToken, 
        email,
        id,
        paymentMethod,
        phone,
        receivedInitialIncentive,
        referral1Success,
        referral2Success,
        referral3Success,
        referralCode, 
        referralCount,
        scrapeAllowed
    ) {
        this.blockReason = blockReason
        this.blocked = blocked
        this.customer = customer
        this.deservesInitialIncentive = deservesInitialIncentive
        this.deservesReward1 = deservesReward1
        this.deservesReward2 = deservesReward2
        this.deviceToken = deviceToken
        this.email = email
        this.id = id
        this.paymentMethod = paymentMethod
        this.phone = phone
        this.receivedInitialIncentive = receivedInitialIncentive
        this.referral1Success = referral1Success
        this.referral2Success = referral2Success
        this.referral3Success = referral3Success
        this.referralCode = referralCode
        this.referralCount = referralCount
        this.scrapeAllowed = scrapeAllowed
    }
}

export class NewSessionDTO {
    constructor(
        appVersion,
        device,
        os,
        browser,
        referrer
    ) {
        this.appVersion = appVersion
        this.device = device
        this.os = os
        this.browser = browser
        this.referrer = referrer
    }
}


export class TextHook2DTO {

    constructor(
        textHook
    ) {
        this.textHook = textHook
    }

    toJSON() {
        return {
            textHook: this.textHook
        }
    }
}


export class ABTestDTO {

    constructor(
        userID,
        environemnt,
        test,
        chosenAction,
    ) {
        this.userID = userID
        this.environemnt = environemnt
        this.test = test
        this.chosenAction = chosenAction
    }

    toJSON() {
        return {
            userID: this.userID,
            environemnt: this.environemnt,
            test: this.test,
            chosenAction: this.chosenAction
        }
    }
}

export class PlateCheckDTO {

    constructor(
        plateToCheck
    ) {
        this.plateToCheck = plateToCheck
    }

    toJSON() {
        return {
            plateToCheck: this.plateToCheck
        }
    }
}

